/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsuranceType } from './InsuranceType';
import {
    InsuranceTypeFromJSON,
    InsuranceTypeFromJSONTyped,
    InsuranceTypeToJSON,
    InsuranceTypeToJSONTyped,
} from './InsuranceType';

/**
 * 
 * @export
 * @interface ConfiguredPayor
 */
export interface ConfiguredPayor {
    /**
     * The payor name
     */
    name: string;
    /**
     * Supported insurance product types for this payor
     */
    insurance_types: Array<InsuranceType>;
}

/**
 * Check if a given object implements the ConfiguredPayor interface.
 */
export function instanceOfConfiguredPayor(value: object): value is ConfiguredPayor {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('insurance_types' in value) || value['insurance_types'] === undefined) return false;
    return true;
}

export function ConfiguredPayorFromJSON(json: any): ConfiguredPayor {
    return ConfiguredPayorFromJSONTyped(json, false);
}

export function ConfiguredPayorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfiguredPayor {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'insurance_types': ((json['insurance_types'] as Array<any>).map(InsuranceTypeFromJSON)),
    };
}

export function ConfiguredPayorToJSON(json: any): ConfiguredPayor {
    return ConfiguredPayorToJSONTyped(json, false);
}

export function ConfiguredPayorToJSONTyped(value?: ConfiguredPayor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'insurance_types': ((value['insurance_types'] as Array<any>).map(InsuranceTypeToJSON)),
    };
}

